
import { Component, Vue } from "vue-property-decorator";
import { TranslateMalay}  from "@/languages/translate_malay";
import { TranslateEn } from "@/languages/translate_en";
import Tabs from 'vue-tabs-with-active-line';
import { CarouselData } from "@/helpers/carouselData";
import UpSkillService from "../../../services/upSkillService";
import { Constant } from "@/helpers/constant";
import moment from 'moment';
import RandomImageService  from "../../../services/randomImageService";
import { DropdownData } from "@/helpers/dropdownData";
import CourseCard from "@/components/courseCard/courseCard.vue";
import Dialog from "primevue/dialog";
import Jobseeker from "@/models/jobseeker";
import { InternationalPhoneCode } from "@/helpers/internationalPhoneCode";
import jobseekerService from "@/services/jobseekerService";

@Component({  components: {
    Tabs,
    CourseCard,
    Dialog
  }
})

export default class Aboutusp extends Vue {
   $loading: any;
  selectedLanguage: string='';
  courseDetailsData:any;
  courseListData:any;
  currentTab:any= '1';
  slotsItem: any = CarouselData.slotsItem;
  skillError:boolean=false;
  cat_id: 1;
  courseDetails: any = {
    courseAttachments: []
  };
  ratingz:any=0;
  venue:any='';
  fullAddress:any='';
  courseId:any=''
  displayLogin:boolean=false;
  tabs:any= [
      { title: 'Course Content', value: '1' },
      { title: 'Course Summary', value: '2' },
   ];
   tabs2:any= [
      
      { title: 'Course Summary', value: '2' },
   ];
   responsiveOptionsTopCarousel:any[]= [
    {
      breakpoint: '1025px',
      numVisible: 1,
      numScroll: 1
    },
    {
      breakpoint: '900px',
      numVisible: 2,
      numScroll: 1
    },
    {
      breakpoint: '770px',
      numVisible: 1,
      numScroll: 1
    },
    {
      breakpoint: '500px',
      numVisible: 1,
      numScroll: 1
    }
  ];
  sloatDetails: any=[];
  searchkeyword: any='';
  relatedkeyskils: any='';
  relatedCourse: any=[];
  courseLength: any=null;
  agencyIdValue: any=DropdownData.agencyId;
  createdByAgency: boolean = false;
  courseDetailsUrl:any = Constant.SERVER_URL+'courseDetails?courseId=';
  trainingModeData: any='';
  showDialog:boolean = false;
  showPreRegDialog:boolean = false;
  jobseeker: Jobseeker = new Jobseeker();
  jobseekerSignupFormData: any = [];
  intlPhoneCodeList: any = [];
  showPassport: any = 0;
  reqjobseeker = new FormData();
  programId:any='';
  courseSessionId:any='';
  elearningURL:any='';

  handleClick(newTab) {
    this.currentTab = newTab;
    this.cat_id=1
  }

  redirectToJobseekerSignup(){
     this.$router.push("/individualSignup");
  }

    created(){
      this.showDialog = false;
      this.showPreRegDialog = false;
      this.selectedLanguage = localStorage.getItem("selectedlanguage");
     let courseIdParam = this.$route.query.courseId
    //  console.log(courseIdParam)
       if(courseIdParam != undefined && courseIdParam != null){
           this.courseId = courseIdParam;
       }else{
           this.courseId = localStorage.getItem("courseId");
      }
     
      if(this.selectedLanguage == 'en')
        {
          this.courseDetailsData = TranslateEn.courseDetailsData;
          this.courseListData = TranslateEn.courseListData;
          this.jobseekerSignupFormData = TranslateEn.jobseekerSignupFormData;
          this.tabs = [ {title: 'Course Content',value:'1'},
                        {title: 'Course Summary',value:'2'},
          ]
        }
          else
        {
          this.courseDetailsData = TranslateMalay.courseDetailsData;
          this.courseListData = TranslateMalay.courseListData;
          this.jobseekerSignupFormData = TranslateMalay.jobseekerSignupFormData;
          this.tabs = [ {title: 'Kandungan Kursus',value:'1'},
                        {title: 'Ringkasan Kursus',value:'2'},
          ]          
        }

        this.intlPhoneCodeList = InternationalPhoneCode.intlPhoneCodes;
        this.slotsItem=this.slotsItem[0].data;

        this.getCourseDetails();
        
    }

  getCourseDetails() {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,
      id:this.courseId
    };
    UpSkillService.getCourseDetails(data).then((response) => {
      loader.hide();
      if (response != undefined) {
        if (response.data.statusCode == 200) {
          if (response.data != undefined && response.data != null && response.data.data.data.courses[0] !='' && response.data.data.data.courses[0] != null && response.data.data.data.courses[0] != undefined )
           {

          
            this.courseDetails = response.data.data.data.courses[0];
            this.relatedkeyskils = this.courseDetails.keySkillId;
            this.sloatDetails= response.data.data.data.courses[0].courseSessions;
            this.ratingz = response.data.data.data.rating;
          
            // if (response.data.data.data.courses[0].courseVenue && response.data.data.data.courses[0].courseVenue.length > 0) {
            //   this.fullAddress = response.data.data.data.courses[0].courseVenue[0].venue[0];
            //   this.venue = this.fullAddress.address+', '+this.fullAddress.city+', '+this.fullAddress.postcode+', '+this.fullAddress.state;
            // }

            const venue = response?.data?.data?.data?.courses?.[0]?.courseVenue?.[0]?.venue?.[0];

            this.programId = this.courseDetails.programId;

            if (venue) {
              this.fullAddress = venue;

              this.venue = [
                venue.address,
                venue.city,
                venue.postcode,
                venue.state
              ]
                .filter(Boolean)
                .join(', ');
            }
          
            this.createdBy(this.courseDetails.createdBy);

            // console.log('testetststss t mode')
            // console.log(this.courseDetails.trainingMode)
            this.courseDetails.trainingMode2 = this.courseDetails.trainingMode;
            this.courseDetails.pillar2 = this.courseDetails.pillar;
            const translation = this.selectedLanguage === 'en'
              ? TranslateEn.courseDetailsData
              : TranslateMalay.courseDetailsData;

            const trainingModeMap = {
              'Blended/Hybrid': translation.blendHybrid,
              'Blended / Hybrid': translation.blendHybrid,
              'Classroom': translation.classRoom,
              'Coaching': translation.coaching,
              'e-Learning': translation.eLearning,
              'ROT_Virtual_Training': translation.onlineTraining,
              'Online': translation.onlineTraining
            };

            this.courseDetails.trainingMode2 =
              trainingModeMap[this.courseDetails.trainingMode] ||
              this.courseDetails.trainingMode;
             
            const pillarMap = {
              'Life Skills': translation.lifeSkill,
              'Future Skills': translation.futureSkill,
              'Creativity & Innovation': translation.creativityInnovation,
              'Financial': translation.financial,
              'Sustainable Development': translation.sustainableDev,
            };

            this.courseDetails.pillar2 =
              pillarMap[this.courseDetails.pillar] ||
              this.courseDetails.pillar;
              
            this.getRelatedCourse();

           }else{
             this.courseDetails=[];
           }
        }
      }
    });
  }

 searchCourse() {
    if (
      this.searchkeyword != undefined &&
      this.searchkeyword != null &&
      this.searchkeyword != ""
    ) {
      this.skillError = false;
      localStorage.setItem("homeSearch",this.searchkeyword);
      this.$router.push('/courseList?search='+this.searchkeyword);
    }
      else {
      this.skillError = true;
    }
  }


  allCourse:any[];

    getRelatedCourse() {
    let loader = this.$loading.show();
    let data = {
      provider: Constant.JOBSEEKER_PROVIDER,
      filter:'',
      menu:'',
      keyskill:this.relatedkeyskils
    };
    UpSkillService.gethomeCourseCount(data).then(
      (response) => {
        loader.hide();


        if (response != undefined) {
          if (response.data.statusCode == 200) {
            if (
              response.data != undefined &&
              response.data != null 
            )
           {
             let courseArry=[]
           this.allCourse =response.data.data.data.courses.data;
           for (let index = 0; index < this.allCourse.length; index++) {
                 if (this.allCourse[index].id != this.courseId) {
                    courseArry.push(this.allCourse[index]);
                 }
           }
           this.relatedCourse = courseArry;
           this.courseLength = this.relatedCourse.length;
           }
          }
        }
      }
    );
  }

  dataEntroll(id, course_session_id, url){
   
    
    localStorage.setItem("entrol",id);
    localStorage.setItem("courseId",this.courseId); 
    localStorage.setItem("courseSessionId",course_session_id);

    this.courseSessionId = course_session_id;  
    this.elearningURL = url; 
    
    //alert(course_session_id)
    //alert(this.elearningURL);

    if(this.courseDetails.trainingMode == 'e-Learning'){
      this.showDialog = true;
    }else{
      this.$confirm(this.courseDetailsData.pleaseEnroll).then(() => {
          localStorage.setItem("entrol",id);
            localStorage.setItem("courseId",this.courseId); 
            this.$router.push("/individualLogin");
      });
    }
    

  }
  
  preReg(){
    this.showPreRegDialog = true;
  }
  
  closePreReg(){
    this.showPreRegDialog=false
  }

   onNationalityChange(event) {
    if (event.target.value == '1') { //local
      this.showPassport = 0;
      this.jobseeker.state = '';
    } else {
      this.showPassport = 1;
      this.jobseeker.state = 'Others';
    }
  }

  submitPreReg() {
    let loader = this.$loading.show();

    const strToSnakeCase = (key) =>
        key &&
        key
          .match(
            /[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
          )
          .map((x) => x.toLowerCase())
          .join("_");
      for (let key in this.jobseeker) {
        if (
          this.jobseeker[key] != undefined &&
          this.jobseeker[key] != null
        ) {
          this.reqjobseeker.append(
            strToSnakeCase(key),
            this.jobseeker[key]
          );
        }
      }
      this.reqjobseeker.append("provider", Constant.JOBSEEKER_PROVIDER);
      this.reqjobseeker.append("program_id", this.programId);
      this.reqjobseeker.append("course_id", this.courseId);
      let sId = localStorage.getItem("courseSessionId");
      
      this.reqjobseeker.append("course_session_id", sId);

    jobseekerService.preRegJobseeker(this.reqjobseeker, Constant.JOBSEEKER_PROVIDER).then(
      (response) => {
        loader.hide();
        if (response != undefined && response.data != undefined) {
          if (response.data.statusCode == 200) {
            this.jobseeker = response.data.data;
            alert("Your Pre-Registration has been done Successfully.");
            //alert( response.data.data.message)
            //  this.$fire({title: 'Success',text: "Your Pre-Registration has been done Successfully.",showCancelButton: false,confirmButtonText: 'OK',type: "success",
            //   backdrop: `
            //   rgba(0,0,1,0.4)
            //   center left
            //   no-repeat
            // `})

            this.$router.push(this.elearningURL);
          } else {
            alert(
              "Your Pre-Registration has not been done successfully. Please try again."
            );
             //alert( response.data.data.message)
            // this.$fire({title: 'Success',text: "Your Pre-Registration has been done Successfully.",showCancelButton: false,confirmButtonText: 'OK',type: "success",
            //   backdrop: `
            //   rgba(0,0,1,0.4)
            //   center left
            //   no-repeat
            // `})
            this.jobseeker = new Jobseeker();
          }
        }
      }
    );
  }

  closeEnrol(){
    this.showDialog=false
  }

  redirectToLogin(){
    this.$router.push("/individualLogin");
  }

  redirectToPreRegistration(courseId){
    //this.$router.push("/individualPreReg");
    this.$router.push({
      path: "/individualPreReg",
      query: {
        courseId: courseId,
      }
    });
  }


dataRedirect(id){

alert(id);
// this.$confirm("Please Login to Enroll a Course").then(() => {
//        localStorage.setItem("entrol",id);
//         localStorage.setItem("courseId",this.courseId); 
        // this.$router.push(id);
  //  });

}

     bannerImage(data:any[]){
      // data= this.courseDetails.courseAttachments;
      // console.log(data.length);
      for (let index = 0; index < data.length; index++) {
        // console.log(index);
          if (data[index].fileType == "courseBanner") {
                let url = "";
                // console.log(index);
          if (
            data[index].fileUrl != undefined && data[index].fileUrl != null && data[index].fileUrl != ""
          ) {
            url = data[index].fileUrl.replace(
              Constant.OSSInternalURL,
              Constant.OSSReplaceURL
            );
            return url;
          }
          }
      }
      
      return null;
          
 }

 referenceAttachment(fileUrl){
      // for (let index = 0; index < data.length; index++) {
          // if (data[index].fileType == "courseBanner") {
          let url = "";
          if (
            fileUrl != undefined && fileUrl != null && fileUrl != ""
          ) {
            url = fileUrl.replace(
              Constant.OSSInternalURL,
              Constant.OSSReplaceURL
            );
            return url;
          }
          // }else{
          //   return null;
          // }
      // }
 }

 relatedCourseDetails(courseId){
  this.$router.push("/courseDetails?courseId="+courseId);
  //  this.$router.replace('/courseDetails')
    localStorage.setItem("courseId",courseId)
    this.courseId = courseId;
    this.getCourseDetails();
    window.scroll(0,0);
 }
  
   formatDate(value){
     const d = new Date(value); 
     let val = moment(d).format('DD MMM YYYY');
     if(val == "Invalid date"){
      return ""
     }
     else{
       return val
     }
  }

formatTime(value){

  let val = value.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [value];

  if (val.length > 1) { // If time format correct
    val = val.slice (1);  // Remove full string match value
    val[5] = +val[0] < 12 ? 'AM' : 'PM'; // Set AM/PM
    val[0] = +val[0] % 12 || 12; // Adjust hours
  }
  val=val[0]+val[1]+ val[2]+' '+val[5];
  
     if(val == "Invalid time"){
      return ""
     }
     else{
       return val
     }
  }
  
  randomImage(){
    return RandomImageService.randomImage();
  }

  randomCpImage(){
    return RandomImageService.randomCpImage();
  }

   createdBy(id:any) {
     for (let index = 0; index < this.agencyIdValue.length; index++) {
        if(this.agencyIdValue[index] == id){
           this.createdByAgency = true;
        } 
      }
    }

  copyUrl(courseId){
      let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = Constant.PLATFORM_URL+'courseDetails?courseId='+courseId;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
      this.$toast.add({severity:'success', summary: 'Success', detail:'Course Link Copied To Clipboard', life: 3000});

  }

//   removeDomain(url){

//     let result = url.replace('http://', "");
//     result = url.replace('https://', "");
//     result = "http://" + result;

//     return result;
//  }
dateTimeNow() {
  var now = new Date();
  var dateString = moment(now).format('YYYY-MM-DD');

  var dateStringWithTime = moment(now).format('YYYY-MM-DD HH:mm:ss');
  return dateStringWithTime;
}

plusDuration(time,date,duration) {
  let hello = '';
  hello = date+' '+time;
  duration = 0; //remove ni kalau nak applicants still boleh enrol during session
  return moment(hello).add(duration, 'h').format('YYYY-MM-DD HH:mm:ss');
}

formatCurrency(value) {
    if (value != null) {
        const numberValue = parseFloat(value);
        if (!isNaN(numberValue)) {
            return 'RM ' + numberValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        }
    }
    return 'RM 0.00';
}

formatRating(value) {
    if (value != null) {
        const numberValue = parseFloat(value);
        if (!isNaN(numberValue)) {
            return numberValue.toFixed(2);
        }
    }
    return '0';
}

redirectToRegistration() {
  this.$router.push("/individualSignup");
}

redirectToCourseList() {
  this.$router.push("/courseList");
}
}
